import { hexToRgba } from '@chronosphereio/core';
import { PaletteMode, PaletteOptions } from '@mui/material';
import { GetThemeOptions } from '../theme';
import {
  unitySemanticDarkColorTokens,
  unitySemanticLightColorTokens,
  xcorDefinedDarkTokens,
  xcorDefinedLightTokens,
} from '../unityTokens';
import { black, green, grey, white } from './colors';
import { buildPaletteFromMetadata, PaletteTokenMetadata, Token } from './panw-palette/token-metadata';

/** For use strictly within @chronosphereio/chrono-ui */
const stepperTokens = [
  { propertyPath: 'connectorColor', tokenName: '--semantic-border-bold' },
  { propertyPath: 'iconBackground', tokenName: '--semantic-bg-interactive-neutral-default' },
  { propertyPath: 'activeIconBackground', tokenName: '--semantic-bg-status-highlight' },
  { propertyPath: 'iconColor', tokenName: '--semantic-bg-input-inverse' },
  { propertyPath: 'activeIconColor', tokenName: '--semantic-text-contrast' },
] satisfies Token[];

export const stepperTokenMetadata: PaletteTokenMetadata = {
  componentName: 'stepper',
  tokens: stepperTokens,
};

export const stepper = (mode: PaletteMode, opts: GetThemeOptions): PaletteOptions['stepper'] => {
  if (opts.panwRebrandStubYear) {
    const tokens = mode === 'light' ? unitySemanticLightColorTokens : unitySemanticDarkColorTokens;
    const xcorTokens = mode === 'light' ? xcorDefinedLightTokens : xcorDefinedDarkTokens;
    return buildPaletteFromMetadata(stepperTokenMetadata.tokens, tokens, xcorTokens);
  }

  // Legacy values that are based on what the MUI Stepper was doing previously.
  return mode === 'light'
    ? {
        connectorColor: grey[400],
        iconBackground: grey[300],
        activeIconBackground: green[600],
        iconColor: white,
        activeIconColor: white,
      }
    : {
        connectorColor: grey[400],
        iconBackground: grey[500],
        activeIconBackground: green[500],
        iconColor: hexToRgba(black, 0.87),
        activeIconColor: hexToRgba(black, 0.87),
      };
};
